import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Rate } from "../../rates/_types/rate";
import { Provider } from "../../providers/_types/provider";

export class ProviderRate extends Resource {
    public override type = 'providerRates';

    @prop()
    public providerId!: string;
    public provider!: Provider;

    @prop()
    public rateId!: string;
    public rate!: Rate;    

    
    @prop()
    public normalServiceAllowed: boolean = true;

    @prop()
    public guardServiceAllowed: boolean = true;

}

